import React from "react";
import YouTubeChannel from "./YouTubeChannel";
import { useGetYoutubeVideo } from "../../../utils/useYoutube";

type Props = {
  link: string;
  pageType: "profile" | "team" | "facility";
  contentId: string;
};
const YouTubeChannelContainer: React.FC<Props> = ({
  link,
  pageType,
  contentId,
}) => {
  const { videoIds, isLoading } = useGetYoutubeVideo({
    pageId: contentId,
    type: pageType,
  });

  return (
    <YouTubeChannel
      youtube_url={link}
      youtube_data={isLoading === false && videoIds ? videoIds : []}
    />
  );
};

export default YouTubeChannelContainer;
